import * as moment from "moment";
export const formatEventDate = (startDate: Date, endDate: Date) => {
	if (!startDate || !endDate) {
		return "";
	}
	if (moment(startDate, "DD-MM-YYYY").isSame(moment(endDate, "DD-MM-YYYY"), "day")) {
		return `${moment(startDate).format("DD MMMM YYYY")} - from ${moment(startDate).format(
			"hh:mm a"
		)} to ${moment(endDate).format("hh:mm a")} `;
	} else {
		return `${moment(startDate).format("DD MMMM YYYY hh:mm a")} - ${moment(endDate).format(
			"DD MMMM YYYY hh:mm a"
		)}`;
	}
};
